import { Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import { FormArray, FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { MatDialog } from "@angular/material";
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import { ToasterService } from "angular2-toaster";
import { CommonService } from "../../../common/commonService";
import { Location } from "@angular/common";
import { urlConstant } from "../../../constant/urlConstant";
import { ModalDirective } from "ngx-bootstrap/modal";
import { Globals } from "../../../globals";
import jsPDF from "jspdf";
import Swal from "sweetalert2";
@Component({
  selector: "app-proforma-invoice-details",
  templateUrl: "./proforma-invoice-details.component.html",
  styleUrls: ["./proforma-invoice-details.component.scss"],
})
export class ProformaInvoiceDetailsComponent implements OnInit {
  @ViewChild("viewBillModal", { static: false })
  public viewBillModal: ModalDirective;
  @ViewChild("pdfContentByInvoice", { static: false })
  pdfContentByInvoice: ElementRef;

  selectedRecepint = new FormControl("");
  showUserEdit: boolean = false;
  invoice: any = {};
  userDetail: any = {};
  recepintList: any[] = [];
  invoiceId: any;
  propertyId: any;
  billTypeList: any[] = [];
  showEdit: Boolean = true;
  showSave: Boolean = false;
  invoiceDescription = new FormControl("");
  invoiceDueDate = new FormControl("");
  generatedBy = new FormControl("");
  invoiceNo = new FormControl("");
  invoiceDate = new FormControl("");
  loginUserDetail: any;
  propertyData: any = {};
  checkedData: any[] = [];
  showButton: boolean = false;
  checked: boolean = false;
  minSelectedDate: string;
  minDate: Date;
  endFormattedDate: string;
  invoiceForm: FormGroup;
  subTotal: number = 0;
  cgstPercentage: number = 0;
  totalCgstAmount: number = 0;
  sgstPercentage: number = 0;
  totalSgstAmount: number = 0;
  totalDiscountAmount: number = 0;
  grandSubTotal: number = 0;
  discountPercentage: number = 0;
  dPercentage = new FormControl("");
  sPercentage = new FormControl("");
  cPercentage = new FormControl("");
  showBankEdit: Boolean = true;
  showBankSave: Boolean = false;
  bankSavedData: any = {
    accountHolder: "",
    bankName: "",
    branch: "",
    accountNumber: "",
    ifscCode: "",
  };
  bankAccount = new FormControl("");
  bankBranch = new FormControl("");
  bankHolder = new FormControl("");
  bankIfsc = new FormControl("");
  bankName = new FormControl("");
  itemList: any[] = [];
  itemNotes = new FormControl("");
  payToId: any;
  company: any;
  section: any;
  openUrlId: any;
  openView: boolean = false;
  sahredUserDetail: any = {};
  showGstInput: boolean = false;
  invoiceGst = new FormControl("");
  otherFirstName = new FormControl("");
  otherLastName = new FormControl("");
  otherNumber = new FormControl("");
  otherEmail = new FormControl("");
  otherAddress = new FormControl("");
  otherGst = new FormControl("");
  billDetails: any[] = [];
  billDetailsBackup: any[] = [];
  formatStartDate: any;
  formatEndDate: any;
  startDate: any;
  endDate: any;
  symbol = "₹";
  receiptType: string;
  backUpInvoiceNumber: any;

  constructor(
    private route: ActivatedRoute,
    private _CommonService: CommonService,
    private toatserService: ToasterService,
    private formBuilder: FormBuilder,
    private dialog: MatDialog,
    private location: Location,
    public sanitizer: DomSanitizer,
    public router: Router
  ) {
    this._CommonService.showLoading();
    this.createForm();
    if (this.location.path().includes("action") === true) {
      this.openView = true;
      this.openUrlId = this.route.snapshot.params.id;
      this._CommonService.showLoading();
      this.getInvoiceOpenUrl();
    } else {
      this.propertyId = this.route.snapshot.params.id.split("_")[0];
      this.invoiceId = this.route.snapshot.params.id.split("_")[2];
      if (this.invoiceId !== undefined && this.invoiceId !== null) {
        this.getParamMaster();
        this.getInvoiceByInvoiceId(this.invoiceId);
      }
      if (this.route.snapshot.params.id.split("_")[3] !== undefined) {
        this.section = this.route.snapshot.params.id.split("_")[3];
      }
    }
  }
  getInvoiceOpenUrl() {
    this._CommonService
      .get<any>(
        urlConstant.ProformaInvoice.getProformaInvoiceOpenUrl +
          "?sharedId=" +
          this.openUrlId
      )
      .subscribe((res: any) => {
        if (res.Status === "200") {
          console.log(res.data);
          if (!!res.data.InvoiceOpenUrl) {
            this.getInvoiceByInvoiceId(
              res.data.InvoiceOpenUrl.proformaInvoiceId
            );
          }
          this.propertyData = res.data.Property;
          this.receiptType = "inv";
        } else {
          this.toatserService.pop("error", "Error", res.message);
        }
      });
  }

  ngOnInit() {
    this.loginUserDetail = this._CommonService.getLoggedInUser();
    if (
      !!this.loginUserDetail &&
      (this.openUrlId === null || this.openUrlId === undefined)
    ) {
      this.getPropertyByPropertyId();
      this.getUserBankDetails();
      this.getBillByPropertyId();
    }
  }

  createForm() {
    this.invoiceForm = this.formBuilder.group({
      invoice: this.formBuilder.array([
        new FormGroup({
          hsnSsc: new FormControl(""),
          itemType: new FormControl(""),
          itemName: new FormControl(""),
          itemDescription: new FormControl(""),
          unitAmount: new FormControl(""),
          quantity: new FormControl(1),
          totalAmount: new FormControl(""),
          showInvoiceSave: new FormControl(false),
          showDropDown: new FormControl(false),
          identityId: new FormControl(null),
          invoiceDetailId: new FormControl(null),
        }),
      ]),
    });
    this.fields.removeAt(0);
  }

  get fields(): FormArray {
    return this.invoiceForm.get("invoice") as FormArray;
  }

  getParamMaster() {
    this._CommonService
      .get<any>(urlConstant.ProformaInvoice.getParamMasterForProformaInvoice)
      .subscribe((res: any) => {
        this.recepintList = res.data.recepintList;
        this.billTypeList = res.data.billTypeList;
      });
  }

  getInvoiceByInvoiceId(invoiceId: any) {
    this._CommonService
      .get<any>(
        urlConstant.ProformaInvoice.getProformaInvoiceByInvoiceId +
          "?proformainvoiceId=" +
          invoiceId
      )
      .subscribe((res: any) => {
        if (res.Status === "200") {
          this.invoice = res.data.Invoice;
          if (!!this.invoice.bankInfo) {
            this.bankSavedData = this.invoice.bankInfo;
          }

          this.company = res.data.Company;
          this.selectedRecepint.setValue(this.invoice.selecteReceipnt);
          this.onChangeRecepint();
          this.patchValuesToDescription(this.invoice);
        }
      });
  }

  patchValuesToDescription(invoice: any) {
    invoice.proformaInvoiceDetailList.map((data: any, index: any) => {
      this.fields.push(
        this.formBuilder.group({
          itemType: new FormControl(data.type),
          itemName: new FormControl(data.name),
          itemDescription: new FormControl(data.itemDescription),
          unitAmount: new FormControl(data.unitAmount),
          quantity: new FormControl(data.quantity),
          totalAmount: new FormControl(Number(data.itemTotalAmount)),
          showInvoiceSave: new FormControl(true),
          showDropDown: new FormControl(false),
          identityId: new FormControl(data.identityId),
          invoiceDetailId: new FormControl(data.id),
          hsnSsc: new FormControl(data.hsnSsc),
        })
      );
    });

    this.itemNotes.patchValue(invoice.notes);
    this.subTotal = this.invoice.subTotal;
    this.cPercentage.setValue(invoice.cgstPercentage);
    this.sPercentage.setValue(invoice.sgstPercentage);
    this.dPercentage.setValue(invoice.discountPercentage);
    this.totalCgstAmount = invoice.cgstAmount;
    this.totalSgstAmount = invoice.sgstAmount;
    this.totalDiscountAmount = invoice.discountAmount;
    this.grandSubTotal = invoice.grandTotal;
    this._CommonService.hideLoading();
  }

  getPropertyByPropertyId() {
    this._CommonService
      .get<any>(
        urlConstant.Property.GetPropertyByPropertyId +
          "?propertyId=" +
          this.propertyId
      )
      .subscribe((res: any) => {
        if (res.Status === "200") {
          this.propertyData = res.data.Property;
        }
      });
  }

  editUser() {
    this.showUserEdit = true;
    this.otherFirstName.setValue(this.invoice.otherFirstName);
    this.otherLastName.setValue(this.invoice.otherLastName);
    this.otherEmail.setValue(this.invoice.otherEmail);
    this.otherNumber.setValue(this.invoice.otherNumber);
    this.otherAddress.setValue(this.invoice.otherAddress);
    this.otherGst.setValue(this.invoice.otherGst);
  }

  saveUser() {
    let userObj = {
      otherFirstName: this.otherFirstName.value,
      otherLastName: this.otherLastName.value,
      otherEmail: this.otherEmail.value,
      otherNumber: this.otherNumber.value,
      otherAddress: this.otherAddress.value,
      otherGst: this.otherGst.value,
      invoiceId: this.invoiceId,
    };

    this._CommonService
      .post(urlConstant.ProformaInvoice.saveProformaInvoiceUserDetail, userObj)
      .subscribe((res: any) => {
        if (res.Status === "200") {
          this.invoice = res.data.Invoice;
          this.showUserEdit = false;
        } else {
          this.toatserService.pop("error", "Error", res.message);
        }
      });
  }

  onChangeRecepint() {
    if (
      this.invoice.userList
        .filter(
          (ele: any) =>
            String(ele.roleName).toLowerCase() ===
            String(this.selectedRecepint.value).toLowerCase()
        )
        .map((val) => val).length > 0
    ) {
      this.invoice.userList
        .filter(
          (ele: any) =>
            String(ele.roleName).toLowerCase() ===
            String(this.selectedRecepint.value).toLowerCase()
        )
        .map((val: any) => {
          this.userDetail = val;
        });
    } else {
      this.userDetail = {};
    }

    let recList = [];
    recList = this.recepintList
      .filter(
        (ele: any) =>
          String(ele.paramValue).toLowerCase() ===
          String(this.selectedRecepint.value).toLowerCase()
      )
      .map((val) => val);
    if (recList !== undefined && recList.length > 0) {
      recList.map((val) => (this.payToId = val.id));
    }
  }

  editGst(userDetail: any) {
    this.showGstInput = true;
    this.invoiceGst.setValue(userDetail.gst);
  }

  saveGst(userDetail: any) {
    let gstObj = {
      proformaInvoiceId: this.invoiceId,
      gst: this.invoiceGst.value,
      roleId: userDetail.roleId,
    };
    this._CommonService.showLoading();
    this._CommonService
      .post(urlConstant.ProformaInvoice.addGstForUsersAtProformaInvoice, gstObj)
      .subscribe((res: any) => {
        if (res.Status === "200") {
          this.invoice = res.data.ProformaInvoice;
          this.selectedRecepint.setValue(this.invoice.selecteReceipnt);
          this.onChangeRecepint();
          this.toatserService.pop("success", "Success", res.message);
          this.showGstInput = false;
          this._CommonService.hideLoading();
        } else {
          this.showGstInput = false;
          this.toatserService.pop("error", "Error", res.message);
          this._CommonService.hideLoading();
        }
      });
  }

  editInvoice(invoice: any) {
    this.backUpInvoiceNumber = null;
    this.showEdit = false;
    this.showSave = true;
    console.log(invoice);
    this.invoiceNo.setValue(
      invoice.proformainvoiceNo !== null ? invoice.proformainvoiceNo : ""
    );
    this.invoiceDate.setValue(
      invoice.invoiceDate !== null
        ? String(invoice.formattedInvoiceDate).split("T")[0]
        : ""
    );
    this.invoiceDescription.setValue(
      invoice.description !== null ? invoice.description : ""
    );
    this.invoiceDueDate.setValue(
      invoice.dueDate !== null
        ? String(invoice.formattedDueDate).split("T")[0]
        : ""
    );
    this.generatedBy.setValue(
      invoice.generatedBy !== null
        ? invoice.generatedBy
        : String(this.loginUserDetail.firstName) +
            " " +
            String(this.loginUserDetail.lastName)
    );
    this.backUpInvoiceNumber = invoice.proformainvoiceNo;
  }

  saveInvoice() {
    let invoiceDetailObj = {
      proformaInvoiceId: this.invoiceId,
      proformaInvoiceNo: this.invoiceNo.value,
      invoiceDate:
        this.invoiceDate.value !== undefined &&
        this.invoiceDate.value !== null &&
        this.invoiceDate.value !== ""
          ? new Date(this.invoiceDate.value).toISOString().split("T")[0]
          : null,
      proformaInvoiceDescription: this.invoiceDescription.value,
      dueDate:
        this.invoiceDueDate.value !== undefined &&
        this.invoiceDueDate.value !== null &&
        this.invoiceDueDate.value !== ""
          ? new Date(this.invoiceDueDate.value).toISOString().split("T")[0]
          : null,
      generatedBy: this.generatedBy.value,
      backUpProformaInvoiceNumber: this.backUpInvoiceNumber,
    };

    this._CommonService.showLoading();
    this._CommonService
      .post(
        urlConstant.ProformaInvoice.saveProformaInvoiceDetail,
        invoiceDetailObj
      )
      .subscribe((res: any) => {
        if (res.Status === "200") {
          this.invoice = res.data.Invoice;
          if (this.invoice.invoiceMessage !== null) {
            Swal.fire({
              title: "Already Exist",
              html:
                "This Invoice ID already exists in system. <br>" +
                " Please create a new Invoice ID",
              icon: "warning",
              showCloseButton: true,
              showConfirmButton: true,
            });
            this.showEdit = false;
            this.showSave = true;
          } else {
            this.showEdit = true;
            this.showSave = false;
            this.toatserService.pop("success", "Success", res.message);
          }

          this._CommonService.hideLoading();
        } else {
          this.toatserService.pop("error", "Error", res.message);
          this._CommonService.hideLoading();
        }
      });
  }

  existingBill() {
    this.checkedData = [];
    this.showButton = false;
    this.checked = false;
    this.billDetails.map((x) => {
      x.checked = false;
    });
    this.viewBillModal.show();
  }

  serachByDate() {
    this.getFilterDateData();
  }

  getFilterDateData() {
    this.billDetails = this.billDetailsBackup
      .filter(
        (ele) =>
          ele.billDueDate >= this.formatStartDate &&
          ele.billDueDate <= this.formatEndDate
      )
      .map((val) => val);
  }

  clearDateFilter() {
    this.startDate = undefined;
    this.endDate = undefined;
    this.formatStartDate = undefined;
    this.formatEndDate = undefined;
    this.billDetails = this.billDetailsBackup;
  }

  selectAll(event) {
    this.billDetails.map((val: any) => {
      if (event === true) {
        val.checked = true;
        this.checked = true;
        this.showButton = true;
        this.checkedData.push(val);
      } else {
        val.checked = false;
        this.checked = false;
        this.showButton = false;
        this.checkedData = [];
      }
    });
  }

  selectIndiviual(event, data) {
    this.checked = false;
    if (event === true) {
      if (this.checkedData.length === 0) {
        this.checkedData.push(data);
        this.showButton = true;
      } else {
        const isFound = this.checkedData.some((ele) => {
          if (ele.billId === data.billId) {
            return true;
          } else {
            return false;
          }
        });

        if (isFound === false) {
          this.checkedData.push(data);
          if (this.checkedData.length > 0) {
            this.showButton = true;
          }
        }
      }
    } else {
      let index = this.checkedData.findIndex((ind) => {
        if (ind.billId === data.billId) {
          return ind;
        }
      });
      if (index !== -1) {
        this.checkedData.splice(index, 1);
      }
      if (this.checkedData.length === 0) {
        this.showButton = false;
      }
    }
  }

  minDateChageEvent(event) {
    this.formatStartDate = Globals.defaultDateFormat(this.startDate);
    this.minSelectedDate = Globals.defaultDateFormat(
      Globals.convertToIST(event.value["_d"])
    );
    this.minDate = new Date(this.minSelectedDate);
  }
  maxDateChageEvent(event) {
    this.formatEndDate = Globals.defaultDateFormat(this.endDate);
    this.endFormattedDate = Globals.defaultDateFormat(
      Globals.convertToIST(event.value["_d"])
    );
  }

  patchValues() {
    this.checkedData.forEach((billingInfoItem) => {
      this.fields.push(
        this.formBuilder.group({
          hsnSsc: new FormControl(""),
          itemType: new FormControl(billingInfoItem.billType),
          itemName: new FormControl(billingInfoItem.billName),
          itemDescription: new FormControl(""),
          unitAmount: new FormControl(billingInfoItem.amount),
          quantity: new FormControl(1),
          totalAmount: new FormControl(
            Number(Number(billingInfoItem.amount) * 1)
          ),
          showInvoiceSave: new FormControl(false),
          showDropDown: new FormControl(false),
          identityId: new FormControl(billingInfoItem.billId),
          invoiceDetailId: new FormControl(null),
        })
      );
    });
    this.viewBillModal.hide();
    this.calculateValues();
    this.onChangeUnitAndQtyTaxValues();
  }

  calculateValues() {
    this.subTotal = 0;
    this.fields.value.map((val: any) => {
      this.subTotal = Number(Number(this.subTotal) + Number(val.totalAmount));
    });
    this.grandTotal();
  }

  handleCgstChange(event: any) {
    this.cgstPercentage = Number(event.target.value);
    this.totalCgstAmount = this.getGstAmount(event.target.value);
    this.grandTotal();
  }

  handleSgstChange(event: any) {
    this.sgstPercentage = Number(event.target.value);
    this.totalSgstAmount = this.getGstAmount(event.target.value);
    this.grandTotal();
  }

  handleCgstkeyup(event: any) {
    this.cgstPercentage = Number(event.target.value);
    this.totalCgstAmount = this.getGstAmount(event.target.value);
    this.grandTotal();
  }

  handleSgstkeyup(event: any) {
    this.sgstPercentage = Number(event.target.value);
    this.totalSgstAmount = this.getGstAmount(event.target.value);
    this.grandTotal();
  }

  grandTotal() {
    let grandSubTotal = Number(
      Number(this.subTotal) +
        Number(this.totalCgstAmount) +
        Number(this.totalSgstAmount)
    );

    if (this.totalDiscountAmount !== null && this.totalDiscountAmount !== 0) {
      this.grandSubTotal = Number(
        Number(grandSubTotal) - Number(this.totalDiscountAmount)
      );
    } else {
      this.grandSubTotal = Number(grandSubTotal);
    }
  }

  getGstAmount(value: any): number {
    return Number(
      Number(Number(value / 100) * Number(this.subTotal)).toFixed(2)
    );
  }

  getGstPercentAmount(value: any): number {
    return Number(
      Number(Number(value / 100) * Number(this.subTotal)).toFixed(2)
    );
  }

  handleDiscountkeyup(event: any) {
    this.discountPercentage = Number(event.target.value);
    this.totalDiscountAmount = this.gesDiscountAmount(event.target.value);
    this.grandTotal();
  }

  handleDiscountChange(event: any) {
    this.discountPercentage = Number(event.target.value);
    this.totalDiscountAmount = this.gesDiscountAmount(event.target.value);
    this.grandTotal();
  }

  gesDiscountAmount(value: any): number {
    return Number(Number(value / 100) * Number(this.subTotal));
  }

  patchTotalAmountByUnitAmount(fieldIndex: any) {
    if (
      this.fields.at(fieldIndex).get("quantity").value !== null &&
      this.fields.at(fieldIndex).get("quantity").value !== undefined
    ) {
      this.fields
        .at(fieldIndex)
        .get("totalAmount")
        .patchValue(
          String(
            Number(this.fields.at(fieldIndex).get("unitAmount").value) *
              Number(this.fields.at(fieldIndex).get("quantity").value)
          )
        );
    } else {
      this.fields
        .at(fieldIndex)
        .get("totalAmount")
        .patchValue(String(this.fields.at(fieldIndex).get("unitAmount").value));
    }
    this.calculateValues();
    this.onChangeUnitAndQtyTaxValues();
  }

  patchTotalAmountByQuantity(fieldIndex: any) {
    this.fields
      .at(fieldIndex)
      .get("totalAmount")
      .patchValue(
        String(
          Number(this.fields.at(fieldIndex).get("unitAmount").value) *
            Number(this.fields.at(fieldIndex).get("quantity").value)
        )
      );
    this.calculateValues();
    this.onChangeUnitAndQtyTaxValues();
  }

  handleQtyChange(fieldIndex: any) {
    this.fields
      .at(fieldIndex)
      .get("totalAmount")
      .patchValue(
        String(
          Number(this.fields.at(fieldIndex).get("unitAmount").value) *
            Number(this.fields.at(fieldIndex).get("quantity").value)
        )
      );
    this.calculateValues();
    this.onChangeUnitAndQtyTaxValues();
  }

  handleUnitAmountChange(fieldIndex: any) {
    if (
      this.fields.at(fieldIndex).get("quantity").value !== null &&
      this.fields.at(fieldIndex).get("quantity").value !== undefined
    ) {
      this.fields
        .at(fieldIndex)
        .get("totalAmount")
        .patchValue(
          String(
            Number(this.fields.at(fieldIndex).get("unitAmount").value) *
              Number(this.fields.at(fieldIndex).get("quantity").value)
          )
        );
    } else {
      this.fields
        .at(fieldIndex)
        .get("totalAmount")
        .patchValue(String(this.fields.at(fieldIndex).get("unitAmount").value));
    }
    this.calculateValues();
    this.onChangeUnitAndQtyTaxValues();
  }

  onChangeUnitAndQtyTaxValues() {
    this.totalDiscountAmount = this.gesDiscountAmount(this.dPercentage.value);
    this.totalSgstAmount = this.getGstAmount(this.sPercentage.value);
    this.totalCgstAmount = this.getGstAmount(this.cPercentage.value);
    this.grandTotal();
  }

  getUserBankDetails() {
    this._CommonService
      .get<any>(
        urlConstant.ProformaInvoice.getUserBankAccount +
          "?invoiceId=" +
          this.invoiceId
      )
      .subscribe((res: any) => {
        if (res.Status === "200") {
          this.bankSavedData = res.data.Bank;
        } else {
          this.bankSavedData = {
            accountHolder: "",
            bankName: "",
            branch: "",
            accountNumber: "",
            ifscCode: "",
          };
        }
      });
  }

  getCompanyDetails() {
    this._CommonService.get<any>(urlConstant.Auth.getCompanyDetail).subscribe(
      (res: any) => {
        if (res.Status === "200" && res.data && res.data.CompanyDetail) {
          this.company = res.data.CompanyDetail;
        } else {
          this.company = null;
        }
      },
      (error) => {
        if (error != null) {
          console.error("error", "Error", error.message);
        }
      }
    );
  }

  formatIndianNumerationWithDecimals(number: number): string {
    return number !== null && number !== undefined
      ? number.toLocaleString("en-IN", { maximumFractionDigits: 2 })
      : "0";
  }

  getDefaultUser(): string {
    return this.loginUserDetail !== undefined && this.loginUserDetail !== null
      ? String(
          this.loginUserDetail.firstName + " " + this.loginUserDetail.lastName
        )
      : String(
          this.sahredUserDetail.firstName + " " + this.sahredUserDetail.lastName
        );
  }

  getBillByPropertyId() {
    this._CommonService
      .get<any>(
        urlConstant.BillUtility.getBillByPropertyId +
          "?propertyId=" +
          this.propertyId +
          "&partnerId=" +
          this.loginUserDetail.partnerId
      )
      .subscribe(
        (res) => {
          this.billDetails = [];
          if (res.Status === "200") {
            this.billDetails = res.data.Bill;
            this.billDetailsBackup = this.billDetails;
            let i = 0;
            this.billDetails.map((x) => {
              x.checked = false;
              x.index = i + 1;
              i++;
            });
          }
          this._CommonService.hideLoading();
        },
        (error) => {
          this.billDetails = [];
          if (error != null) {
            this.toatserService.pop("error", "Error", error.message);
          }
          this._CommonService.hideLoading();
        }
      );
  }

  removeItemPatch(fieldIndex: any, data: any) {
    if (this.fields.at(fieldIndex).get("invoiceDetailId").value !== null) {
      Swal.fire({
        title: "Item Delete Conformation?",
        html: "Are you sure you want to remove the details",
        icon: "warning",
        showConfirmButton: true,
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "Sure",
        cancelButtonText: "Cancel",
      }).then((result) => {
        if (result.isConfirmed) {
          this._CommonService.showLoading();
          this._CommonService
            .post(
              urlConstant.ProformaInvoice.deleteProformaInvoiceDetail +
                "?invoiceDetailId=" +
                this.fields.at(fieldIndex).get("invoiceDetailId").value +
                "&invoiceId=" +
                this.invoiceId,
              null
            )
            .subscribe((res: any) => {
              if (res.Status === "200") {
                this.toatserService.pop("success", "Success", res.message);
                this.pathcValuesAfterDelete(res.data.Invoice);
              }
            });
        }
      });
    } else {
      this.fields.removeAt(fieldIndex);
      this.calculateValues();
      this.onChangeUnitAndQtyTaxValues();
    }
  }

  clearFormArray() {
    while (this.fields.length !== 0) {
      this.fields.removeAt(0);
    }
  }

  pathcValuesAfterDelete(invoice: any) {
    this.clearFormArray();
    invoice.invoiceDetailList.map((data: any, index: any) => {
      this.fields.push(
        this.formBuilder.group({
          itemType: new FormControl(data.type),
          itemName: new FormControl(data.name),
          itemDescription: new FormControl(data.itemDescription),
          unitAmount: new FormControl(data.unitAmount),
          quantity: new FormControl(data.quantity),
          totalAmount: new FormControl(Number(data.itemTotalAmount)),
          showInvoiceSave: new FormControl(true),
          showDropDown: new FormControl(false),
          identityId: new FormControl(data.identityId),
          invoiceDetailId: new FormControl(data.id),
        })
      );
    });

    this.itemNotes.patchValue(invoice.notes);
    this.subTotal = invoice.subTotal;
    this.cPercentage.setValue(invoice.cgstPercentage);
    this.sPercentage.setValue(invoice.sgstPercentage);
    this.dPercentage.setValue(invoice.discountPercentage);
    this.totalCgstAmount = invoice.cgstAmount;
    this.totalSgstAmount = invoice.sgstAmount;
    this.totalDiscountAmount = invoice.discountAmount;
    this.grandSubTotal = invoice.grandTotal;
    this._CommonService.hideLoading();
  }
  showItemPatch(fieldIndex: any) {
    this.fields.at(fieldIndex).get("showInvoiceSave").setValue(false);
    if (this.fields.at(fieldIndex).get("identityId").value !== null) {
      this.fields.at(fieldIndex).get("showDropDown").setValue(true);
    } else {
      this.fields.at(fieldIndex).get("showDropDown").setValue(false);
    }
  }

  createItemPatch() {
    this.fields.push(
      new FormGroup({
        itemType: new FormControl(""),
        itemName: new FormControl(""),
        itemDescription: new FormControl(""),
        unitAmount: new FormControl(""),
        quantity: new FormControl(1),
        totalAmount: new FormControl(""),
        showInvoiceSave: new FormControl(false),
        showDropDown: new FormControl(false),
        identityId: new FormControl(null),
        invoiceDetailId: new FormControl(null),
        hsnSsc: new FormControl(""),
      })
    );
  }

  editBank(bankSavedData: any) {
    this.showBankEdit = false;
    this.showBankSave = true;
    if (!Globals.isObjectEmpty(this.bankSavedData)) {
      this.patchBankValues(bankSavedData);
    } else {
      this.bankAccount.setValue("");
      this.bankBranch.setValue("");
      this.bankHolder.setValue("");
      this.bankIfsc.setValue("");
      this.bankName.setValue("");
    }
  }

  saveBank() {
    let bankObj = {};
    if (!!this.bankSavedData) {
      bankObj = {
        primaryId: this.bankSavedData.id,
        invoiceId: this.invoice.id,
        acoountHolderName: this.bankHolder.value,
        bankName: this.bankName.value,
        branch: this.bankBranch.value,
        accountNumber: this.bankAccount.value,
        ifscCode: this.bankIfsc.value,
      };
    } else {
      bankObj = {
        invoiceId: this.invoice.id,
        acoountHolderName: this.bankHolder.value,
        bankName: this.bankName.value,
        branch: this.bankBranch.value,
        accountNumber: this.bankAccount.value,
        ifscCode: this.bankIfsc.value,
      };
    }
    this._CommonService.showLoading();
    this._CommonService
      .post(urlConstant.ProformaInvoice.userBankDetails, bankObj)
      .subscribe((res: any) => {
        if (res.Status === "200") {
          this.toatserService.pop("success", "Success", res.message);
          this.showBankEdit = true;
          this.showBankSave = false;
          this.bankSavedData = res.data.Bank;
          this.patchBankValues(res.data.Bank);
        } else {
          this.toatserService.pop("error", "Error", res.message);
        }
      });
  }

  patchBankValues(bankSavedData: any) {
    this.bankAccount.setValue(bankSavedData.accountNumber);
    this.bankBranch.setValue(bankSavedData.branch);
    this.bankHolder.setValue(bankSavedData.accountHolder);
    this.bankIfsc.setValue(bankSavedData.ifscCode);
    this.bankName.setValue(bankSavedData.bankName);
    this._CommonService.hideLoading();
  }

  saveInvoiceDescription() {
    let invoiceDto = {};
    this.itemList = [];
    for (let i = 0; i < this.fields.value.length; i++) {
      let descriptionList = {
        type: this.fields.value[i].itemType,
        name: this.fields.value[i].itemName,
        itemDescription: this.fields.value[i].itemDescription,
        unitAmount: Number(this.fields.value[i].unitAmount),
        quantity: Number(this.fields.value[i].quantity),
        itemTotalAmount: Number(this.fields.value[i].totalAmount),
        identityId: this.fields.value[i].identityId,
        invoiceDetailId: this.fields.value[i].invoiceDetailId,
        hsnSsc: this.fields.value[i].hsnSsc,
      };
      this.itemList.push(descriptionList);
    }

    invoiceDto = {
      proformaInvoiceId: this.invoiceId,
      notes: this.itemNotes.value,
      subTotal: Number(this.subTotal),
      cgstPercentage:
        this.cPercentage.value !== null &&
        this.cPercentage.value !== undefined &&
        this.cPercentage.value !== ""
          ? Number(this.cPercentage.value)
          : null,
      cgstAmount: Number(this.totalCgstAmount),
      sgstPercentage:
        this.sPercentage.value !== null &&
        this.sPercentage.value !== undefined &&
        this.sPercentage.value !== ""
          ? Number(this.sPercentage.value)
          : null,
      sgstAmount: Number(this.totalSgstAmount),
      discountPercentage:
        this.dPercentage.value !== null &&
        this.dPercentage.value !== undefined &&
        this.dPercentage.value !== ""
          ? Number(this.dPercentage.value)
          : null,
      discountAmount: Number(this.totalDiscountAmount),
      grandTotal: Number(this.grandSubTotal),
      itemList: this.itemList,
      emailSend:
        this.invoice.proformaInvoiceDetailList !== null &&
        this.invoice.proformaInvoiceDetailList.length > 0
          ? false
          : true,
      payToId:
        this.payToId !== undefined && this.payToId !== null
          ? String(this.payToId)
          : "",
    };

    this._CommonService.showLoading();
    this._CommonService
      .post(
        urlConstant.ProformaInvoice.saveProformaInvoiceInformation,
        invoiceDto
      )
      .subscribe((res: any) => {
        if (res.Status === "200") {
          this.toatserService.pop("success", "Success", res.message);
          this.router.navigateByUrl(
            `admin/invoice-performa/add-view-invoice/${this.propertyId}`
          );
        } else {
          this.toatserService.pop("error", "Error", res.message);
          this._CommonService.hideLoading();
        }
      });
  }

  nonEmptyUser(userDetail: any) {
    return !Globals.isObjectEmpty(userDetail);
  }
}
